import * as React from 'react';
import { ToolbarDirection } from '../../actions/UIModeAction';
import { toolbarSize } from '../../style/values';
import { zIndex } from '../../constants';

interface SecondaryToolbarProps {
  readonly direction: ToolbarDirection;
}

const SecondaryToolbar: React.SFC<SecondaryToolbarProps> = (props) => {
  const style: React.CSSProperties = {
    position: 'absolute',
    background: 'rgba(128, 128, 128, 0.8)',
    display: 'flex',
    alignItems: 'center',
    zIndex: zIndex.secondaryToolbar,
  };

  const { direction, children } = props;
  const { VerticalLeft, Horizontal, VerticalRight } = ToolbarDirection;

  switch (direction) {
    case VerticalLeft: {
      style.width = `${toolbarSize}px`;
      style.height = '100%';
      style.left = `${toolbarSize}px`;
      style.top = 0;
      style.flexDirection = 'column';
      break;
    }
    case Horizontal: {
      style.width = '100%';
      style.height = `${toolbarSize}px`;
      style.top = `${toolbarSize}px`;
      style.left = 0;
      style.flexDirection = 'row';
      break;
    }
    case VerticalRight: {
      style.width = `${toolbarSize}px`;
      style.height = '100%';
      style.right = `${toolbarSize}px`;
      style.top = 0;
      style.flexDirection = 'column';
      break;
    }
  }

  return (
    <section style={style}>
      {children}
    </section>
  );
};

export default SecondaryToolbar;
